/* The Glow Up Guide — Singapore waitlist. Reveal-on-scroll + scroll-to-form. Safe in the theme editor. */
(function(){
  document.documentElement.classList.add('gugsg-js');

  function reveal(root){
    var design = window.Shopify && window.Shopify.designMode;
    var items = root.querySelectorAll('.gugsg-reveal');
    if(design || !('IntersectionObserver' in window)){
      items.forEach(function(el){ el.classList.add('gugsg-in'); });
      return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('gugsg-in'); io.unobserve(e.target); } });
    }, { threshold:.14, rootMargin:'0px 0px -40px 0px' });
    items.forEach(function(el){ io.observe(el); });
  }

  // Intrinsic height of the theme header, so we reserve room for it when scrolling
  // the form into view. We use offsetHeight (not the live rect) on purpose: many
  // themes auto-hide the header on scroll-down and slide it back in on scroll-up,
  // so at click time it may be off-screen but it WILL cover the top once we scroll up.
  function topInset(){
    var sels = ['#shopify-section-header','sticky-header','.header-wrapper','.site-header','.section-header','.header__wrapper','header'];
    for(var i=0;i<sels.length;i++){
      var el = document.querySelector(sels[i]);
      if(el){
        var h = el.offsetHeight;
        if(h > 0 && h < 300) return h;
      }
    }
    return 0;
  }

  // Set scroll-margin-top on every form card so ANY scroll-to-anchor (native href
  // jump, scrollIntoView, or our own) stops below the sticky header, never under it.
  function setScrollMargins(){
    var off = topInset() + 20;
    document.querySelectorAll('.gugsg-capture').forEach(function(el){ el.style.scrollMarginTop = off + 'px'; });
  }

  function scrollToForm(el){
    var off = topInset() + 20;
    var top = el.getBoundingClientRect().top + window.pageYOffset - off;
    if(top < 0) top = 0;
    try{ window.scrollTo({ top: top, behavior:'smooth' }); }
    catch(e){ window.scrollTo(0, top); }
  }

  // Delegated click handling — works for every CTA regardless of when it renders.
  document.addEventListener('click', function(e){
    var a = e.target.closest ? e.target.closest('[data-gugsg-join]') : null;
    if(!a) return;
    e.preventDefault();
    var el = document.getElementById(a.getAttribute('data-gugsg-join'));
    if(el){ setScrollMargins(); scrollToForm(el); }
  });

  function init(root){
    var scope = root || document;
    reveal(scope);
    setScrollMargins();
    // after a successful signup the page reloads with the success card; bring it into view
    var ok = scope.querySelector('.gugsg-ok');
    if(ok){
      var card = ok.closest('.gugsg-capture') || ok;
      scrollToForm(card);
    }
  }

  if(document.readyState !== 'loading'){ init(document); }
  else { document.addEventListener('DOMContentLoaded', function(){ init(document); }); }

  window.addEventListener('resize', setScrollMargins);
  // re-init when the section is added/edited in the theme customizer
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
